/*
 *
 * LanguageProvider reducer
 *
 */

import { fromJS } from 'immutable';
import type { Map } from 'immutable';
import type { AnyAction } from 'redux';

import { CHANGE_LOCALE } from './constants';
import { DEFAULT_LOCALE, getBrowserLanguage } from '../../i18n';

export type LanguageState = Map<string, string>;

export const initialState: LanguageState = fromJS({
  locale: getBrowserLanguage() || DEFAULT_LOCALE,
});

/* eslint-disable default-case, no-param-reassign */
function languageProviderReducer(
  state: LanguageState = initialState,
  action: AnyAction,
): LanguageState {
  switch (action.type) {
    case CHANGE_LOCALE:
      return state.set('locale', action.locale);
    default:
      return state;
  }
}

export default languageProviderReducer;
